import styled from 'styled-components';

export const UploadingMeta = styled.div`
  max-width: 40rem;
`;

/* TODO clean up styled components without styles (still used on the add model page) */
export const DescriptionMeta = styled.div``;
export const IniParametersWrapper = styled.div``;
export const ModelImageView = styled.div``;
export const ImageMessage = styled.div``;
export const DescriptionImageWrapper = styled.div``;
